import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { niveauxService } from "../../services";
import { CustomDialog, Loading, showToast } from "..";
import { Bâtiment, Site } from "../../interfaces";
import { AutoComplete } from "primereact/autocomplete";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../utils/UserProvider";
import { InputNumber } from 'primereact/inputnumber';

interface ModalAddNiveauProps {
  modalIsOpenNiveau: boolean;
  closeModalNiveau: () => void;
  batiments: Bâtiment[];
  sites: Site[];
}

const ModalAddNiveau = ({
  modalIsOpenNiveau,
  closeModalNiveau,
  batiments,
  sites,
}: ModalAddNiveauProps) => {
  const queryClient = useQueryClient();
  const { client } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedBâtiment, setSelectedBâtiment] = useState<Bâtiment | null>(
    null
  );
  const [filteredBâtiments, setFilteredBâtiments] = useState<Bâtiment[]>([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data: any) => {
    try {
      let niveauData = {};
      if (selectedBâtiment) {
        data.bâtiment_id = selectedBâtiment.id;
        data.numero = parseInt(data.numero, 10);
        niveauData = {
          nom_niveau: data.nom_niveau,
          env_client_id: client.id,
          bâtiment_id: selectedBâtiment.id,
          numero: parseInt(data.numero, 10),
          nombre:data.nombre,
        };
        if (data.numero_ordre) {
          niveauData = {
            nom_niveau: data.nom_niveau,
            bâtiment_id: selectedBâtiment.id,
            env_client_id: client.id,
            numero: data.numero,
            numero_ordre: parseInt(data.numero_ordre, 10),
            nombre:data.nombre,
           
          };
          data.numero_ordre = parseInt(data.numero_ordre, 10);
        }
        setLoading(true);
        await niveauxService.post(niveauData).then(() => {
          setLoading(false);
          showToast("success", "Niveau ajouté avec succès");
          queryClient.refetchQueries({
            queryKey: ["niveaux"],
          });

          closeModalNiveau();
          setSelectedBâtiment(null);

          reset();
        });
      } else {
        showToast("warning", "veuillez sélectionner un bâtiment");
      }
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  const search = (event) => {
    setTimeout(() => {
      let _filteredBâtiments;

      if (!event.query.trim().length) {
        _filteredBâtiments = [...batiments];
      } else {
        _filteredBâtiments = batiments.filter((batiment) => {
          return batiment.nom_bâtiment
            .toLowerCase()
            .includes(event.query.toLowerCase());
        });
      }

      setFilteredBâtiments(_filteredBâtiments);
    }, 250);
  };

  const itemTemplate = (option) => {
    const bâtiment = batiments.find((b) => b.id === option?.id);
    const site = sites.find((site) => site.id === bâtiment?.site_id);

    return (
      <div>
        {site ? (
          <span>{`${site.nom_site} / ${bâtiment.nom_bâtiment}`}</span>
        ) : (
          <span>{bâtiment.nom_bâtiment}</span>
        )}
      </div>
    );
  };

  return (
    <>
      <CustomDialog
        header="Ajouter un niveau"
        closeModalDialog={() => {
          closeModalNiveau();
          setSelectedBâtiment(null);
          reset();
        }}
        visible={modalIsOpenNiveau}
      >
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <div className="relative w-full h-full ">
            <div className="p-6 space-y-6">
              <div className="grid grid-cols-6 gap-6">
                <div className="col-span-3 sm:col-span-3">
                  <label
                    htmlFor="nom_niveau"
                    className="block text-md font-bold leading-6 text-gray-900"
                  >
                    Nom *
                  </label>
                  <input
                    type="text"
                    name="nom_niveau"
                    id="nom_niveau"
                    placeholder="Saisir nom"
                    className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                    {...register("nom_niveau", {
                      required: true,
                      maxLength: 20,
                    })}
                  />
                  {errors.nom_niveau && (
                    <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                      champs obligatoire
                    </span>
                  )}
                </div>


                <div className="col-span-3 sm:col-span-3">
                  <label
                    htmlFor="nom_niveau"
                    className="block text-md font-bold leading-6 text-gray-900"
                  >
                    Nombre *
                  </label>
                  <input
                    type="number"
                    step="1" 
                    min="1"
                    max="10"
                    name="nombre"
                    id="nombre"
                    placeholder="Saisir le Nombre"
                    className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                    {...register("nombre", {
                      required: "Champs obligatoire",
                      min: { value: 1, message: "Le nombre doit être supérieur ou égal à 1" },
                      max: { value: 10, message: "Le nombre doit être inférieur ou égal à 10" },
                      validate: (value) =>
                        /^\d+(\.\d{1,2})?$/.test(value) || "Veuillez entrer un nombre décimal valide",
                    })}
                  />
                  {errors.nombre && (
                    <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                      champs obligatoire
                    </span>
                  )}
                  
                  </div>








                <div className="col-span-3 sm:col-span-3">
                  <label
                    htmlFor="numero"
                    className="block text-md font-bold leading-6 text-gray-900"
                  >
                    Numéro *
                  </label>
                  <input
                    type="text"
                    name="numero"
                    id="numero"
                    placeholder="Saisir le numéro"
                    className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                    {...register("numero", {
                      required: true,
                    })}
                  />
                  {errors.numero && (
                    <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                      champs obligatoire
                    </span>
                  )}
                </div>
                <div className="col-span-3 sm:col-span-3">
                  <label
                    htmlFor="numero_ordre"
                    className="block text-md font-bold leading-6 text-gray-900"
                  >
                    Numéro d'ordre *
                  </label>
                  <input
                    type="text"
                    id="numero_ordre"
                    name="numero_ordre"
                    placeholder="Saisir le numéro d'ordre "
                    className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                    {...register("numero_ordre")}
                  />
                 
                </div>


     



                <div className="col-span-6 sm:col-span-6">
                  <label
                    htmlFor="bâtiment_id"
                    className="block text-md font-bold leading-6 text-gray-900"
                  >
                    Choisir bâtiment *
                  </label>

                  <AutoComplete
                    value={selectedBâtiment}
                    suggestions={filteredBâtiments}
                    field="nom_bâtiment"
                    completeMethod={search}
                    onChange={(e) => setSelectedBâtiment(e.value)}
                    placeholder="Sélectionner un bâtiment"
                    itemTemplate={itemTemplate}
                    className="h-12 my-3 border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200  w-full "
                    dropdown
                  />
                </div>
              </div>
              <p className=" text-lg font-thin my-4">* obligatoire</p>

              <div className="flex justify-end">
                <button
                  type="submit"
                  className="text-white mt-5  bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
                >
                  {loading && (
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline w-4 h-4 mr-3 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                  )}
                  Ajouter
                </button>
              </div>
            </div>
          </div>
        </form>
      </CustomDialog>
      {loading && <Loading />}
    </>
  );
};

export default ModalAddNiveau;
